import { Title, type TitleProps } from '@mantine/core';

// H1 раздела кабинета — Onest 700, сдержанный размер, тёмно-зелёный brand-9.
// ТОЛЬКО для крупных заголовков страниц-разделов и приветствия. См. design-guidelines.
export default function PageTitle(props: TitleProps) {
  return (
    <Title
      order={1}
      fz={{ base: 24, sm: 28 }}
      fw={600}
      c="brand.9"
      {...props}
    />
  );
}
